export default __webpack_public_path__ + "static/sleep-38207aec1aa2055afed674ac91ad4a76.png";